<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="part">The characters in this novel are fictional. No real persons are portrayed. The places do not necessarily correspond to geography. That is to say, New York is New York, but localities in Alabama, Mississippi, and Louisiana have been deliberately scrambled. For example, the Southern city herein set forth bears certain resemblances to Birmingham. But the nearby university is more like the state institution in Mississippi. The town of Shut Off, Louisiana, is not across the Mississippi River from Vicksburg. These liberties are taken as a consequence of my impression that this region as a whole, comprising parts of Alabama, Mississippi, and Louisiana, shares certain traits which set it apart from much of the United States and even from the rest of the South.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-part.vue?184b0866